import { isNetworkError } from './is-network-error';

export function shouldSendToSentry(error: unknown): boolean {
  // Don't send 5xx, 401, abort errors, or network errors to Sentry
  if (error && typeof error === 'object') {
    const status = 'status' in error ? (error.status as number) : undefined;

    // Check for 5xx errors
    if (status && status >= 500 && status < 600) {
      return false;
    }

    // Check for 401 errors
    if (status === 401) {
      return false;
    }

    // Check for abort errors
    if (error instanceof DOMException && error.name === 'AbortError') {
      return false;
    }

    // Check for network errors
    if (isNetworkError(error)) {
      return false;
    }
  }

  return true;
}
